import React, { useEffect } from 'react';

const MilestoneListeners = ({ eventEmitter, applyStoreAction }) => {
    const listen = () => {
        eventEmitter.on('milestone_added', milestone => {
            applyStoreAction({
                type: 'MILESTONE_ADD_SOCKET',
                payload: {
                    milestone: {
                        ...milestone,
                        start: new Date(milestone.start).getTime(),
                        end: new Date(milestone.end).getTime()
                    }
                }
            });
        });

        eventEmitter.on('milestone_edited', milestone => {
            applyStoreAction({
                type: 'MILESTONE_UPDATE_SOCKET',
                payload: {
                    milestoneId: milestone.id,
                    milestone: {
                        ...milestone,
                        start: new Date(milestone.start).getTime(),
                        end: new Date(milestone.end).getTime()
                    }
                }
            });
        });

        eventEmitter.on('milestone_removed', milestone => {
            applyStoreAction({
                type: 'MILESTONE_REMOVE_SOCKET',
                payload: {
                    milestoneId: milestone.id
                }
            });
        });

    }

    useEffect(listen, []);

    return null;
}

export default MilestoneListeners;
